export default __webpack_public_path__ + "static/media/vivo_four.eaea465a.webp";